import { render, staticRenderFns } from "./Manifest.vue?vue&type=template&id=072f79de"
import script from "./Manifest.vue?vue&type=script&lang=js"
export * from "./Manifest.vue?vue&type=script&lang=js"
import style0 from "./Manifest.vue?vue&type=style&index=0&id=072f79de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports